import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from '@auth0/auth0-react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Environment from './Environment';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const onRedirectCallback = (appState: any) => {
  window.history.replaceState({}, document.title, appState?.returnTo || window.location.pathname);
};

root.render(
  <Auth0Provider
    domain={Environment.GetAuthDomain()}
    clientId={Environment.GetAuthClientId()}
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience: Environment.GetAuthAudience(),
      scope: Environment.GetAuthScope()
    }}
    onRedirectCallback={onRedirectCallback}
  >
    <App />
  </Auth0Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
